import BasePageLayout from "../../components/layouts/base-page-layout/base-page-layout";
import EditorPageLayout from "../../components/layouts/editor-page/editor-page-layout";
import LocalesListStore from "./stores/locales-list-store";
import { useEffect } from "react";
import LocaleList from "./components/locale-list/locale-list";
import { observer } from "mobx-react";
import LocaleStore from "./stores/locale-store";
import "./portal-and-emails-language-page.scss";
import Card from "../../components/layouts/card/card";
import FontBody1 from "../../components/fonts/font-body1/font-body1";
import FontHeading3 from "../../components/fonts/font-heading3/font-heading3";
import { FONT_COLOR, FONT_VARIANT } from "../../components/fonts/font-props";
import { CARD_SPACING_VARIANT } from "../../components/layouts/card/card.types";
import DownloadTranslationsContainer from "./components/download-translations-container/download-translations-container";
import UploadTranslationsContainer from "./components/upload-translations-container/upload-translations-container";
import currentPortalStore from "../../stores/current-portal-store";
import currentAccountStore from "../accounts/stores/current-account-store";
import AddLanguageButton from "./components/add-language-button/add-language-button";


const PortalAndEmailsLamguagePage: React.FC = observer(() => {

    const localesList: LocaleStore[] = LocalesListStore.localesList;

    useEffect(() => {
        LocalesListStore.load();
        currentPortalStore.load();
    }, [])

    const handleSave = (): void => {
        LocalesListStore.save();
    }

    return (
        <div className="portal-and-emails-language-page">
            <BasePageLayout
                title="Settings"
                subTitles={["Portal & Emails Languages"]}
                instruction={<>
                    Define the languages you want to enable for your customers.
                </>}>
                
            <EditorPageLayout
                toolbar={
                    {saveButton:
                    {
                        hasChanges: LocalesListStore.hasChanges(),
                        disabled: !LocalesListStore.hasChanges() || LocalesListStore.isBusy() || LocalesListStore.isUploading(),
                        onClick: (() => handleSave()),
                    },
                    content: <FontHeading3 variant={FONT_VARIANT.BOLD}>{"Supported languages"}</FontHeading3>,
                    hasBack: false,
                    hasLocalesSelector: false,
                    isLoading: LocalesListStore.isBusy(),
                    }
                }
                >
                <div className="portal-and-emails-language-page-main">
                    <div className="portal-and-emails-language-page-main-table">
                        <Card >
                            <AddLanguageButton />
                            <LocaleList localesList={localesList}/>
                        </Card>
                    </div>
                    <div className="portal-and-emails-language-page-main-sidebar">
                        <Card spacingVariant={CARD_SPACING_VARIANT.SMAll}> 
                            <div>
                                <FontHeading3 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>{"Languages Configuration"}</FontHeading3>
                                <div className="portal-and-emails-language-page-main-sidebar-description">
                                    <FontBody1 color={FONT_COLOR.PRIMARY2}>
                                        {"Download the current translation file, add your translations, then upload it back to update all language texts."}
                                    </FontBody1>
                                </div>
                                <DownloadTranslationsContainer />
                                {(currentPortalStore.setting?.enablePortalV2 || currentAccountStore.isSysAdmin) && (
                                    <UploadTranslationsContainer />
                                )}
                            </div>
                        </Card>    
                    </div>
                </div>

            </EditorPageLayout>

            </BasePageLayout>
        </div>
    );
});

export default PortalAndEmailsLamguagePage;
